const initState = {
    profile: [],
    error_message: null,
    profile_updated: null,

};

const settingsReducer = (state = initState, action) => {


    switch (action.type) {


        case "PROFILE_UPDATED_RESET":
            return {
                ...state,
                profile_updated: null,
            };

        case "PROFILE_UPDATED":
            return {
                ...state,
                profile_updated: true,
            };

        case "RESET_ERROR_MESSAGE":
            return {
                ...state,
                error_message: null,
                profile_updated: null,
            };

        case "ERROR_MESSAGE":
            return {
                ...state,
                error_message: action.error_message,
            };

      
        case "PROFILE":
            return {
                ...state,
                profile: action.profile,
            };


        default:
            return state;
    }
};

export default settingsReducer;
